import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  viewBox: "0 0 14 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8,0 C9.65685425,-3.04359188e-16 11,1.34314575 11,3 L11,7 C11,8.65685425 9.65685425,10 8,10 C6.34314575,10 5,8.65685425 5,7 L5,3 C5,1.34314575 6.34314575,3.04359188e-16 8,0 Z M9,13.9291111 L9,16 L7,16 L7,13.9291111 C3.60770586,13.4438815 1,10.5264719 1,7 L3,7 C3,9.76142375 5.23857625,12 8,12 C10.7614237,12 13,9.76142375 13,7 L15,7 C15,10.5264719 12.3922941,13.4438815 9,13.9291111 Z",
      transform: "translate(-1)"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-mic"}) } }